import { useCallback, useState } from 'react';
import { MassEditBlock } from '../../routes/scenario-planner/components/mass-edit-sidebar/mass-edit-sidebar.component';
import { postScenarioPlannerInput } from '../../services/scenario-planner.service';
import { FilterSelectedValue } from '../filters/interfaces/filter-selected-value.interface';

export const useScenarioPlannerReset = (
  scenarioPlannerId: string,
  filterSelection: FilterSelectedValue[],
  editBlocks: MassEditBlock[],
  crossElastBlocks: MassEditBlock[],
  onResetCallback: () => void,
  mode?: string,
) => {
  const [isResetting, setIsResetting] = useState(false);

  const handleReset = useCallback(async () => {
    setIsResetting(true);
    if (crossElastBlocks && crossElastBlocks.length > 0) {
      await postScenarioPlannerInput<any>(
        scenarioPlannerId,
        crossElastBlocks,
        filterSelection,
        true,
        'cross',
      );
    }
    if (editBlocks && editBlocks.length > 0) {
      // Reset inputs, main elasticity, and starting metrics
      await postScenarioPlannerInput<any>(
        scenarioPlannerId,
        editBlocks,
        filterSelection,
        true,
        mode,
      );
    }
    onResetCallback();
    setIsResetting(false);
  }, [
    editBlocks,
    crossElastBlocks,
    scenarioPlannerId,
    filterSelection,
    mode,
    onResetCallback,
  ]);
  // Reset Cross Elasticities
  return {
    handleReset,
    isResetting,
  };
};
